/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContainerQueryResult } from '../../models/get-container-query-result';

export interface ApiContainersGetContainerGet$Params {
  Id?: string;
}

export function apiContainersGetContainerGet(http: HttpClient, rootUrl: string, params?: ApiContainersGetContainerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainerQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiContainersGetContainerGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContainerQueryResult>;
    })
  );
}

apiContainersGetContainerGet.PATH = '/api/Containers/GetContainer';
